/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/routes';
import store from '@/store';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.simulation) && !store.state.simulation.activePackage) {
    next({
      path: '/',
      query: {
        ...to.query
      }
    });
  } else {
    next();
  }

  if ((!to.meta.showTimeline && !to.matched[0].meta.showTimeline) && store.getters['timeline/getVisibility']) {
    store.dispatch('timeline/setVisibility', false);
  }
});

router.afterEach((to) => {
  if ((to.meta.showTimeline || to.matched[0].meta.showTimeline) && !store.getters['timeline/getVisibility']) {
    store.dispatch('timeline/setVisibility', true);
  }
});

Vue.router = router;

export default {
  router
};



// WEBPACK FOOTER //
// ./src/plugins/vue-router.js